import "./styles/main.css";
import Swal from "sweetalert2";
import { Router } from "./shared/router/Router.js";
import { AuthService } from "./shared/services/AuthService.js";
import { ApiService } from "./shared/utils/ApiService.js";
import { registrarInstalacion } from "./installApp.js";

// Un 401 significa que el token vencio. Se maneja aca y no adentro de ApiService porque este no
// puede importar AuthService (AuthService ya lo importa a el). Importa sobre todo desde que los
// datos quedan cacheados sin vencimiento: sin este aviso la app seguiria mostrando polizas
// guardadas como si la sesion siguiera viva.
const manejarSesionExpirada = () => {
  AuthService.logout();
  Swal.fire({
    icon: "info",
    iconColor: "#12608f",
    title: "Tu sesión expiró",
    text: "Por seguridad cerramos la sesión. Ingresá de nuevo para ver tus pólizas.",
    confirmButtonText: "Ingresar",
    confirmButtonColor: "#12608f",
  });
};

const initApp = async () => {
  ApiService.onSesionExpirada = manejarSesionExpirada;
  const isAuthenticated = await AuthService.checkAuth();
  const router = new Router(isAuthenticated);
  router.init();
  registrarInstalacion();
};

document.addEventListener("DOMContentLoaded", initApp);
